import { Image, Database, Search, AlertCircle } from 'lucide-react';
import { MainBodyData, KeyTakeawaysData } from './types';

export const cybintContent: MainBodyData = {
  number: '03',
  title: 'Cyber Intelligence (CYBINT)',
  icon: Image,
  sections: {
    overview: "Cyber Intelligence (CYBINT) is the process of gathering and analysing public technical data such as IP Addresses, domain information, SSL certificates and past data breaches to build a profile of one's digital footprint and threat landscape.",
    note: "Active reconnaissance is typically not a part of OSINT CYBINT investigations. Ensure proper authorization before actively scanning a network.",
    steps: [
      { title: "Past Breaches", description: "Has the person or company been involved in past data breaches?" },
      { title: "Public Data", description: "Are there publicly released data breach information? What information was compromised?" },
      { title: "Digital Footprint", description: "What online systems or services are being used? (Domains, Email Services, Platforms)" },
      { title: "Security Weakness", description: "Are there signs of poor cyber security hygiene?" },
      { title: "Risk & Impact", description: "What is the current cyber risk level?" },
    ],
    platforms: ["Have I Been Pwned", "DeHashed/Pastebin", "WHOIS", "Shodan", "Wappalyzer", "VirusTotal"],
    dataPoints: [
      "Any past data breaches?",
      "What exposed data can we collect?",
      "What digital assets are being used?",
      "What technology stack is being used?",
      "Malicious indicators associated with the IP/Domain?",
      "Timeline of exposure?"
    ]
  }
};

export const cybintTakeaways: KeyTakeawaysData = {
  sectionTitle: "CYBINT",
  takeaways: [
    "Always verify breach information across multiple sources before drawing conclusions",
    "Document all findings with timestamps and source URLs for evidence chain",
    "Assess the severity of exposed data types (financial, personal, credentials, etc.)",
    "Look for patterns in breach timing that may indicate targeted compromise",
    "Cross-reference technical indicators with historical security events",
    "Maintain ethical boundaries and comply with laws when accessing breach data"
  ],
  tools: [
    { name: "Have I Been Pwned", category: "BREACH DATABASE", description: "Search for email addresses in known data breaches", url: "haveibeenpwned.com", icon: Database},
    { name: "Shodan", category: "IP SCANNING", description: "Search engine for internet-connected devices and services", url: "shodan.io", icon: Search  },
    { name: "VirusTotal", category: "MALWARE ANALYSIS", description: "Analyze suspicious files and URLs for threats", url: "virustotal.com", icon: AlertCircle  },
    { name: "Wappalyzer", category: "TECH DETECTION", description: "Identify technologies and software used on websites", url: "wappalyzer.com", icon: Database  },
    { name: "BinaryEdge", category: "INTERNET SCANNING", description: "Comprehensive internet host scanning and discovery", url: "binaryedge.io", icon: Database  },
    { name: "WHOIS Lookup", category: "DOMAIN RESEARCH", description: "Retrieve domain registration and WHOIS information", url: "whois.net", icon: Database  },
  ]
};